module.exports = __webpack_public_path__ + "media/שמח.b2d229cb.mp3";